module.exports = __webpack_public_path__ + "img/JO.edb2212e.png";